import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { StopTraversalException } from "./utils/StopTraversalException";
import { VisitorContext } from "./context";
export var traverse = function traverse(rootNode, traverseApi) {
  var state = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var context = new VisitorContext(traverseApi, state);
  var visit = function visit(node, params) {
    context.enter(node, params);
    // FIXME: state.opts - костыль, нужно убрать
    if (!context.skipped) node.accept({
      visit: visit,
      params: _objectSpread(_objectSpread({}, state.opts), params)
    });
    context.exit();
  };
  try {
    visit(rootNode);
    return context.state;
  } catch (err) {
    if (err instanceof StopTraversalException) return context.state;
    throw err;
  }
};